module.exports = __webpack_public_path__ + "img/ATG.044456a6.jpg";